import styled from 'styled-components';

export const BreadcrumbNav = styled.nav`
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 24px;
  margin-top: 16px;
`;

export const BreadcrumbList = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;

  p, a {
    font-size: 18px;
    margin: 0;
    color: #000000;
    text-decoration: underline;

    &:hover {
      text-decoration: underline;
    }
  }

  &:not(:last-child)::after {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #CC0000;
    border-radius: 50%;
    margin: 0 12px;
    position: relative;
    top: 1px;
  }

  &:last-child p {
    font-weight: bold;
    color: #CC0000;
    cursor: default;
    text-decoration: none;
  }
`;
